import { render, staticRenderFns } from "./bookerHotels.vue?vue&type=template&id=45059ed6&scoped=true"
import script from "./bookerHotels.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerHotels.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerHotels.vue?vue&type=style&index=0&id=45059ed6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45059ed6",
  null
  
)

export default component.exports